import * as Scrivito from "scrivito"
import { defaultPageAttributes } from "scrivito/Objs/shared/defaultAttributes"

export const ProjectTeamInvitationListPageObjClass = Scrivito.provideObjClass(
  "ProjectTeamInvitationListPage",
  {
    attributes: defaultPageAttributes,
    extractTextAttributes: ["body"]
  }
)
export type ProjectTeamInvitationListPage = InstanceType<
  typeof ProjectTeamInvitationListPageObjClass
>
